/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStackForward = createReactComponent("stack-forward", "IconStackForward", [
  [
    "path",
    { d: "M12 5l-8 4l8 4l8 -4l-8 -4", fill: "currentColor", key: "svg-0" }
  ],
  ["path", { d: "M10 12l-6 3l8 4l8 -4l-6 -3", key: "svg-1" }]
]);

export { IconStackForward as default };
//# sourceMappingURL=IconStackForward.js.map
